import type { FC } from "react";
import cn from "classnames";
import React, { useEffect, useRef, useState } from "react";
import { noop } from "@litres/utils";
import { Button } from "@litres/ui-kit/button";
import { Input } from "@litres/ui-kit/input";
import { DeleteTextIcon } from "../../../../static/icons/DeleteTextIcon";

import styles from "./SearchForm.module.scss";

interface SearchFormProps {
  value?: string;
  onChange: (value: string) => void;
  onSearchClick?: () => void;
  onClearClick?: () => void;
}

export const SearchForm: FC<SearchFormProps> = ({
  value,
  onChange,
  onSearchClick = noop,
  onClearClick = noop,
}) => {
  const searchInputRef = useRef<HTMLInputElement>(null);
  const [searchValue, setSearchValue] = useState(value || "");

  useEffect(() => {
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [searchInputRef]);

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
    onChange(e.target.value);
  };

  const handleSubmitSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSearchClick();
  };

  const handleClearClick = () => {
    setSearchValue("");
    onClearClick();
  };

  return (
    <form
      className={styles.mobileSearchForm}
      data-testid="search__form--mobile"
      action="/search/"
      method="get"
      autoComplete="off"
      onSubmit={handleSubmitSearch}
    >
      <Input
        className={styles.mobileSearchForm__searchInput}
        placeholder="Искать на Литрес"
        onChange={handleOnChange}
        value={searchValue}
        e2eId="search__suggestions--input"
        ref={searchInputRef}
      />
      {!!searchValue && (
        <span
          className={cn(styles.mobileSearchForm__clear)}
          onClick={handleClearClick}
        >
          <DeleteTextIcon />
        </span>
      )}
      <Button
        className={styles.mobileSearchForm__searchButton}
        size="small"
        mode="primary"
        text="Найти"
        onClick={onSearchClick}
        type="submit"
        e2eId="search__suggestions--button"
      />
    </form>
  );
};
